// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_231ca4', '__Inter_Fallback_231ca4'","fontStyle":"normal"},"className":"__className_231ca4","variable":"__variable_231ca4"};